import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';
import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';

import type { AiSuggestionsPlugin } from '../aiSuggestionsPluginType';
import { updateSuggestions } from '../ui/utils/updateSuggestions';
import type { RefreshSuggestionsAction } from './types';

export const refreshSuggestionsAction = (
	api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined,
	contentAri?: string,
): RefreshSuggestionsAction => {
	return async (options): Promise<boolean> => {
		if (!api) {
			return false;
		}

		const regenerateOnly = options?.regenerateOnly ?? false;

		/**
		 * Quick way to get the doc PMNode
		 * since we don't have access to editorView here
		 */
		const getDoc = (): PMNode | undefined => {
			let doc: PMNode | undefined;
			api.core?.actions.execute(({ tr }) => {
				doc = tr.doc;
				return null;
			});
			return doc;
		};
		await updateSuggestions({
			api,
			contentAri,
			getDoc,
			shouldRegenerate: true,
			regenerateOnly,
			regenerationTrigger: options?.regenerationTrigger ?? 'suggestionsUpdated',
		});
		return true;
	};
};
